<form class="filter-form" [formGroup]="filter_memberForm" >
    <h3 class="text-center">Filter</h3>
    <div class="form-group">

        <select class="form-control" formControlName="blood_group">
            <option hidden value="" disabled selected>બ્લડ ગ્રુપ </option>
            <option value="O-">O-</option>
            <option value="O+">O+</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="No idea">No idea</option>
        </select>

    </div>
  
    <div class="form-group">
        <select class="form-control" formControlName="village_name">
            <option hidden value="" disabled selected>ગામ</option>
            <option *ngFor="let name of villageListAll" [value]="name.maternal_village_name">
                {{name.maternal_village_name}}</option>
        </select>
    </div>
    
    <div class="row">
        <div class="col-6">
            <div class="form-group">
                <button type="reset" class="btn-common w-100 closeBtn">રદ કરો</button>
            </div>
        </div>
        <div class="col-6">
            <div class="form-group">
                <button type="submit" class="btn-common w-100" (click)="submit()">મોકલવું</button>
            </div>

        </div>
    </div>
</form>